"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCountryCodes = void 0;
const euCountryCodes = [
    'AD',
    'AL',
    'BA',
    'BG',
    'BY',
    'EE',
    'GR',
    'HR',
    'IS',
    'IT',
    'LI',
    'LT',
    'LU',
    'LV',
    'MC',
    'MD',
    'MK',
    'MT',
    'RO',
    'RU',
    'SI',
    // 'SJ',
    'SK',
    'SM',
    'TR',
    'UA',
    // 'VA',
    // 'YU',
];
const gbCountryCodes = ['UK', 'FO', 'GG', 'GI', 'IM', 'JE'];
// Map EU and UK countries to the correct country code
const mapCountryCodes = (countryCode) => {
    if (euCountryCodes.includes(countryCode))
        return 'EU';
    if (gbCountryCodes.includes(countryCode))
        return 'GB';
    return countryCode;
};
exports.mapCountryCodes = mapCountryCodes;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFwLWNvdW50cnktY29kZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbG9jYWxlL21hcC1jb3VudHJ5LWNvZGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLE1BQU0sY0FBYyxHQUFjO0lBQ2hDLElBQUk7SUFDSixJQUFJO0lBQ0osSUFBSTtJQUNKLElBQUk7SUFDSixJQUFJO0lBQ0osSUFBSTtJQUNKLElBQUk7SUFDSixJQUFJO0lBQ0osSUFBSTtJQUNKLElBQUk7SUFDSixJQUFJO0lBQ0osSUFBSTtJQUNKLElBQUk7SUFDSixJQUFJO0lBQ0osSUFBSTtJQUNKLElBQUk7SUFDSixJQUFJO0lBQ0osSUFBSTtJQUNKLElBQUk7SUFDSixJQUFJO0lBQ0osSUFBSTtJQUNKLFFBQVE7SUFDUixJQUFJO0lBQ0osSUFBSTtJQUNKLElBQUk7SUFDSixJQUFJO0lBQ0osUUFBUTtJQUNSLFFBQVE7Q0FDVCxDQUFDO0FBRUYsTUFBTSxjQUFjLEdBQUcsQ0FBQyxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksQ0FBQyxDQUFDO0FBRTVELHNEQUFzRDtBQUMvQyxNQUFNLGVBQWUsR0FBRyxDQUFDLFdBQW9CLEVBQUUsRUFBRTtJQUN0RCxJQUFJLGNBQWMsQ0FBQyxRQUFRLENBQUMsV0FBVyxDQUFDO1FBQUUsT0FBTyxJQUFJLENBQUM7SUFDdEQsSUFBSSxjQUFjLENBQUMsUUFBUSxDQUFDLFdBQVcsQ0FBQztRQUFFLE9BQU8sSUFBSSxDQUFDO0lBRXRELE9BQU8sV0FBVyxDQUFDO0FBQ3JCLENBQUMsQ0FBQztBQUxXLFFBQUEsZUFBZSxtQkFLMUIifQ==